function CorporateSocialInvestment() {
    return (
        <>
            <section className="corporateSocialInvestment py-0" id="corporate-iocial-investments">
                <div className="max-940 mx-auto p-3 p-sm-4 p-md-5 bg-white position-relative z-1">
                    <h2 className="text-green-38B652">Corporate Social Investment (CSI) at SAMSA</h2>

                   <p>The South African Maritime Safety Authority (SAMSA) embraces Corporate Social Investment (CSI) as a vital expression of its commitment to national development, community upliftment, and environmental stewardship. Our approach to CSI is guided by the belief that meaningful change happens when organisations act with purpose, collaborate widely, and serve communities with empathy and accountability.</p>
                    <p>In line with our values, SAMSA’s CSI activities aim to contribute to a more equitable and sustainable society, while reflecting our broader mandate to advance South Africa’s socio-economic development.
                </p><p>

                      <span className="d-block text-primary-green" style={{ fontSize: '20px', fontWeight: 700 }}>Our CSI Ethos​</span>
                    </p>
                    <ul className="green-star-ul">
                        <li>Driven by values of collaboration, responsiveness, empathy, and accountability.</li>
                        <li>Focused on practical, high-impact action that responds to real community needs.</li>
                        <li>Committed to building partnerships that amplify positive outcomes.</li>
                    </ul>
                    {/* <div className="">
                <h3 className="font-18 mb-4 text-green-38B652"><span className="font-600 text-primary-green">CSI PROJECTS :</span> on maritime rural development involve<br className="d-none d-md-block"/> focus areas as follows:</h3>
                <div className="row g-3">
                    <div className="col-auto">
                        <div className="focus-block bg-green-0d964e rounded-2">
                            <div className="icon"><i className="educate-icon"></i></div>
                            <p>Education</p>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="focus-block bg-primary-green rounded-2">
                            <div className="icon"><i className="multi-user-icon"></i></div>
                            <p>Water skill development</p>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="focus-block bg-orange-ee8029 rounded-2">
                            <div className="icon"><i className="shop-icon"></i></div>
                            <p>Enterpreneurial focus</p>
                        </div>
                    </div>
                </div>
            </div> */}
                </div>
            </section>
        </>
    )
}

export default CorporateSocialInvestment;